// 게이트웨이 연결 실패 원인 진단 (클라이언트 휴리스틱).
//  웹소켓 핸드셰이크 실패는 브라우저가 원인을 숨기므로, HTTP(/health)로 서버 생사를 확인한다.
//   1) CORS fetch — 읽히면 서버 생존: ok→E_SOCKET(HTTP는 되는데 소켓만 실패), 아니면 정확한 코드(HTTP_5xx)
//   2) 읽기 차단(TypeError)이면 no-cors 재시도 — 응답이 "오긴 하면" CF 에러 페이지(525 등) = E_5XX,
//      응답 자체가 없으면 DNS/오프라인 = E_NETWORK
//  (CF 에러 페이지는 CORS 헤더가 없어 상태코드를 읽을 수 없다 — 정확한 숫자가 필요해지면 엣지 프로브로 확장)
const TIMEOUT_MS = 5000;

function fetchTimeout(url, options = {}) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
  return fetch(url, { ...options, signal: ctrl.signal, cache: "no-store" }).finally(() => clearTimeout(t));
}

export default async function diagnoseGateway() {
  const base = process.env.VUE_APP_GATEWAY_HOST_URL;
  if (!base) return "E_NETWORK";
  const url = `${base}/health`;
  try {
    const res = await fetchTimeout(url);
    return res.ok ? "E_SOCKET" : `HTTP_${res.status}`;
  } catch (e) {
    try {
      await fetchTimeout(url, { mode: "no-cors" });
      return "E_5XX"; // 응답은 왔으나 읽기 차단 — 중간자(CF) 에러 페이지 추정
    } catch (e2) {
      return "E_NETWORK"; // 응답 자체 없음
    }
  }
}
